import { axiosRef } from '.';

export const getCountries = () =>
  axiosRef.get(`/countries?is_pagination=false`);

export const getProvinces = (code: string) =>
  axiosRef.get(`/provinces?&country=${code}&is_pagination=false`);

export const validatePostalCode = (payload: any) =>
  axiosRef.post(`/postal_code/validate`, payload);

export const getRouteFormOptions = () =>
  axiosRef.get(`/options?is_pagination=false`);

export const getPublicPackages = () => axiosRef.get(`/package_types`);

export const getNatureOfGoods = (is_food: boolean) =>
  axiosRef.get(`/nature_of_goods?is_food=${is_food}`);

export const fetchRatesPackages = (payload: any) =>
  axiosRef.post(`/rate`, payload);

export const requestQuoteEmail = (payload: any) =>
  axiosRef.post(`/request_quote`, payload);

export const validatePromoCode = (payload: any) =>
  axiosRef.post(`/promo_code/validate`, payload);

export const getPickupTimezone = (payload: any) =>
  axiosRef.get(
    `/pickup/timezone?city=${payload.city}&province=${payload.province}&country=${payload.country}`,
  );

export const getPickupValidate = (id: any) =>
  axiosRef.get(`/pickup/validate?carrier_ids=${id}`);

export const verifyPickupValidate = (payload: any) =>
  axiosRef.post(`/pickup/validate`, payload);

export const makeShipment = (payload: any) => axiosRef.post(`/ship`, payload);

export const manualShipment = (payload: any) =>
  axiosRef.post(`/manual_ship`, payload);

export const addLegInShipment = (payload: any) =>
  axiosRef.post(`/ship/leg`, payload);

export const shipmentHistory = (payload?: any) => {
  let url = `/old/shipments?`;

  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.startDate) {
    url = url + `start_date=${payload.startDate}&end_date=${payload.endDate}&`;
  }
  if (payload && payload.status && payload.status !== '') {
    url = url + `shipment_status=${payload.status}&`;
  }
  if (payload && payload.username && payload.username !== '') {
    url = url + `username=${payload.username}&`;
  }
  if (payload && payload.account) {
    url = url + `account=${payload.account}&`;
  }
  if (payload && payload.gateway_number) {
    url = url + `gateway_number=${payload.gateway_number}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const legsHistory = (payload?: any) => {
  let url = `/old/legs?is_pagination=false&start_date=${payload.startDate}&end_date=${payload.endDate}&shipment_status=${payload.status}&`;
  if (payload && payload.username && payload.username !== '') {
    url = url + `username=${payload.username}&`;
  }
  if (payload && payload.account) {
    url = url + `account=${payload.account}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const shipmentDetails = (id: string) =>
  axiosRef.get(`/old/shipments/${id}`);

// export const legsDetails = (id: string) => axiosRef.get(`/legs/${id}`);
export const legsDetails = (id: string, legId?: string) => {
  let url = `/old/legs/${id}`;
  if (legId && legId !== '') {
    url = url + `?leg_id=${legId}&`;
  }
  return axiosRef.get(url);
};

export const editLegDetails = (payload: any) =>
  axiosRef.put(`/old/legs/${payload?.shipment_id}`, payload);

export const shipmentPackages = (id: string, isAdmin?: boolean) => {
  let url = '/packages';

  if (isAdmin) {
    url = `/admin${url}`;
  }

  return axiosRef.get(`${url}?shipment_id=${id}&is_pagination=false`);
};

export const fetchShipmentDocuments = (id: string, isAdmin: Boolean) =>
  axiosRef.get(
    `${
      isAdmin ? '/admin' : ''
    }/documents/shipment?shipment_id=${id}&is_pagination=false`,
  );

export const addShipmentDocuments = (payload: any, isAdmin: Boolean) =>
  axiosRef.post(`${isAdmin ? '/admin' : ''}/documents/shipment`, payload);

export const editShipmentDocuments = (
  id: any,
  payload: any,
  isAdmin: Boolean,
) =>
  axiosRef.put(`${isAdmin ? '/admin' : ''}/documents/shipment/${id}`, payload);

export const addLegsDocuments = (payload: any, isAdmin: Boolean) =>
  axiosRef.post(`${isAdmin ? '/admin' : ''}/documents/leg`, payload);

export const editLegsDocuments = (id: any, payload: any, isAdmin: Boolean) =>
  axiosRef.put(`${isAdmin ? '/admin' : ''}/documents/leg/${id}`, payload);

export const deleteShipmentDocument = (id: any, isAdmin: Boolean) =>
  axiosRef.delete(`${isAdmin ? '/admin' : ''}/documents/shipment/${id}`);

export const deleteLegDocument = (id: any, isAdmin: Boolean) =>
  axiosRef.delete(`${isAdmin ? '/admin' : ''}/documents/leg/${id}`);

export const cancelShipment = (payload: any) =>
  axiosRef.post(`/cancel`, payload);

export const cancelLeg = (payload: any) => axiosRef.post(`/cancel`, payload);

export const downloadQuotePdf = (type: number, quoteId: any) =>
  axiosRef.get(`/books/quote/${quoteId}/download/${type}`);

export const unNumberInfo = (payload: any) =>
  axiosRef.post(`dangerous_goods/old_unnumbers`, payload);

export const getPackingTypesData = () =>
  axiosRef.get(`dangerous_goods/packing_types`);
